import {
  Component,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
  ViewChild,
  inject,
} from '@angular/core';
import {
  NgbActiveModal,
  NgbModal,
  NgbNav,
  NgbNavChangeEvent,
} from '@ng-bootstrap/ng-bootstrap';
import { CommonComponent } from '@components/abstract/common-component.component';
import { CommonVerbsApiService } from '@services/common/common-verbs-api.service';
import { CoreMediaService } from '@services/common/media.service';
import { ICommunityService } from '@tokens/injection.tokens';
import { Media } from '@models/media/media.model';
import { Router } from '@angular/router';
import { base64ToFile2 } from '@functions/files';
import { environment } from '@environments/environment';

@Component({
  selector: 'app-gallery-util',
  templateUrl: './gallery-util.component.html',
  styleUrls: ['./gallery-util.component.scss'],
  styles: [],
})
export class GalleryUtilComponent extends CommonComponent {
  // Inputs
  @Input() imageUrl: string | undefined | any = undefined;
  @Input() widthPx: number;
  @Input() heightPx: number;
  @Input() showDeleteIcon = false;

  // Modal
  private modalService = inject(NgbModal);
  @ViewChild('imageModal', { static: true }) imageModal: TemplateRef<Element>;

  // API
  protected api: CommonVerbsApiService = inject(CommonVerbsApiService);

  // Not Verified
  @ViewChild('outlet', { static: true }) outlet: NgbNav;
  modal = inject(NgbActiveModal);
  private service = inject(CoreMediaService);
  @Output() emitter = new EventEmitter<File | Media>();

  active = 1;
  disabled = true;
  file: File | undefined = undefined;
  media: Media;

  // Headless
  private router = inject(Router);
  headLess = false;

  // Harmony Customization
  communityService = inject(ICommunityService);
  isHarmonyCorp =
    this.communityService.model?.corporation.id === environment.harmonyCorpId;

  constructor() {
    super();
    const segments = this.router.url.split('/');
    this.headLess = segments.indexOf('headless') != -1;
  }

  async onSelect(media: Media) {
    if (media) {
      this.media = media;
      const base = await this.service.getBase64Image(`${media.url}`);
      if (base) {
        base64ToFile2(`${base}`, `${media.name}`, 'image/jpg').then(file => {
          if (file) {
            this.file = file;
            // this.outlet.select(3);
            this.active = 3;
            this.disabled = false;
          }
        });
      }
    }
  }

  navChange($event: NgbNavChangeEvent<any>) {
    this.active = $event.activeId;
    this.disabled = $event.activeId !== 3;
    if ($event.activeId !== 3) {
      this.file = undefined;
    }
  }

  onKeep() {
    this.emitter.emit(this.media);
    this.imageUrl = this.media.url;
    this.modalService.dismissAll();
  }

  onCrop(e: any) {
    this.api
      .post('media/upload-from-base-64', {
        base64: e.base64,
      })
      .subscribe((res: any) => {
        this.imageUrl = res.url;
        this.emitter.emit(res);
        this.modalService.dismissAll();
      });
  }

  onDeleteImage() {
    this.imageUrl = undefined;
    this.emitter.emit(undefined);
  }

  onOpenModal() {
    this.modalService.dismissAll();
    this.modalService.open(this.imageModal, {
      ariaLabelledBy: 'modal-basic-title',
      size: 'lg',
    });
  }
}
